import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { CloseHistoryStats, OpenHistoryStats } from './history.actions';
import { HistoryState } from './history.state';
import { Observable } from 'rxjs';
import { HistoryItemStats } from './models/history-item-stats.model';
import { HistoryItem } from '../../../models/history-user';

@Injectable({
  providedIn: 'root',
})
export class HistoryFacade {
  private readonly store = inject(Store);

  @Select(HistoryState.isStatsModalOpen) isStatsModalOpen$!: Observable<boolean>;
  @Select(HistoryState.historyItemStats) historyItemStats$!: Observable<HistoryItemStats | undefined>;
  @Select(HistoryState.selectedHistoryItem) selectedHistoryItem$!: Observable<HistoryItem | undefined>;
  @Select(HistoryState.isLoading) isLoading$!: Observable<boolean>;

  openStatsModal(historyItem: HistoryItem, type: string, parentId: string | null = null) {
    this.store.dispatch(new OpenHistoryStats(historyItem, type, parentId));
  }

  closeStatsModal() {
    this.store.dispatch(new CloseHistoryStats());
  }
}
